import { render, staticRenderFns } from "./bankMenu.vue?vue&type=template&id=f915e594"
import script from "./bankMenu.vue?vue&type=script&lang=js"
export * from "./bankMenu.vue?vue&type=script&lang=js"
import style0 from "./bankMenu.vue?vue&type=style&index=0&id=f915e594&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports